import React from "react";
import AuthenticityTokenField from "../../../components/forms/AuthenticityTokenField";
import { Button } from "../../../components/ui/button";
import type { MainAppPageProps, OrgInvitation } from "../types";

type RevokeOrganizationInviteFormProps = Pick<
  MainAppPageProps,
  "csrfToken" | "routes"
> & {
  invitation: OrgInvitation;
};

function revokeAction(
  template: string | undefined,
  invitationId: string,
  fallback: string,
) {
  return (template ?? fallback).replace(":id", invitationId);
}

export const RevokeOrganizationInviteForm: React.FC<
  RevokeOrganizationInviteFormProps
> = ({ csrfToken, routes, invitation }) => {
  const action = revokeAction(
    routes.revokeOrganizationInvitation,
    invitation.id,
    `/organization/members/invitations/${invitation.id}`,
  );

  return (
    <form action={action} method="post">
      <AuthenticityTokenField csrfToken={csrfToken} />
      <input type="hidden" name="_method" value="delete" />
      <Button type="submit" variant="outline" size="sm">
        Revoke
      </Button>
    </form>
  );
};
